import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { OkrKeyResult } from "server/models"
import { StateType } from "client/utils"
import {
    StoreType,

    LoadOkrObjectiveKeyResults,
    ClearParentsOkrObjective,
    DeleteOkrObjective,

    setOkrObjectiveShowConfirmDelete,
    setOkrObjectiveReloadList,
} from "client/store"
import {
    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
    Button,
    SpinnerIcon,
} from "client/components"

const ConfirmDelete = () => {
    const activeObjective = useSelector((state: StoreType) => state.okrObjective.active)
    const showConfirm = useSelector((state: StoreType) => state.okrObjective.showConfirmDelete)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [deleteState, setDeleteState] = useState<StateType>(IDLE)

    const onCancel = () => {
        dispatch(setOkrObjectiveShowConfirmDelete(false))
    }

    const onConfirm = () => {
        setDeleteState(PENDING)
        // clear parents
        Promise.all([
            ClearParentsOkrObjective({
                sessionId: activeObjective.sessionId,
                objectiveId: activeObjective.id,
                keyResultId: null,
            }),
            LoadOkrObjectiveKeyResults(activeObjective.id, activeObjective.sessionId).then((res) => {
                const promiseArray: Promise<any>[] = []
                Object.values(res.keyResultList).forEach((keyResult: OkrKeyResult) => {
                    promiseArray.push(
                        ClearParentsOkrObjective({
                            sessionId: keyResult.sessionId,
                            objectiveId: null,
                            keyResultId: keyResult.id,
                        }),
                    )
                })
                return Promise.all(promiseArray)
            }),
        ]).then(() => {
            DeleteOkrObjective(activeObjective.id, activeObjective.sessionId).then(() => {
                setDeleteState(IDLE)
                dispatch(setOkrObjectiveShowConfirmDelete(false))

                dispatch(setOkrObjectiveReloadList(false))
                setTimeout(() => {
                    dispatch(setOkrObjectiveReloadList(true))
                }, 0)
            })
        })
    }

    return (
        <ConfirmWrapper show={showConfirm} onClose={onCancel}>
            <Confirm>
                <ConfirmTitle>{activeObjective && activeObjective.title}</ConfirmTitle>
                <ConfirmDescription>{lang.deleteObjectiveConfirm}</ConfirmDescription>

                <ConfirmBottom>
                    <Button row onClick={onCancel}>{lang.cancel}</Button>
                    <Button variant="success" row onClick={onConfirm}>
                        {deleteState === PENDING ? <SpinnerIcon /> : lang.confirm}
                    </Button>
                </ConfirmBottom>
            </Confirm>
        </ConfirmWrapper>
    )
}
export default ConfirmDelete
